export default class OrderStatusBoard {
  static get PENDING() {
    return {
      status: [1,7],
      name: 'REALIZADO / AGENDADO',
      identifier: 'pending',
    }
  }

  static get IN_PREPARATION() {
    return {
      status: 8,
      name: 'EN PREPARACIÓN',
      identifier: 'in_preparation',
    }
  }

  static get READY() {
    return {
      status: 5,
      name: 'PEDIDO LISTO',
      identifier: 'ready',
    }
  }

  static get IN_ROUTE() {
    return {
      status: 2,
      name: 'EN RUTA',
      identifier: 'in_route',
    }
  }

  static get CANCELED() {
    return {
      status: 6,
      name: 'CANCELADO',
      identifier: 'canceled',
    }
  }

  static get DELIVERED() {
    return {
      status: 3,
      name: 'ENTREGADO',
      identifier: 'delivered',
    }
  }
}
